export default "__VITE_ASSET__DdInxGT___"